export const TIMELINE_MAGIC = 1000
export const TIMELINE_HEADER_SIZE = 4
export const TIMELINE_SEGMENT_SIZE = 5
export const TIMELINE_KIND_HOLD = 0
export const TIMELINE_KIND_GLIDE = 1
